import React, { ReactNode } from "react";
import { connect } from "react-redux";

import { defineMessages, useIntl } from "react-intl";

import { Alert, Button } from "@mapmycustomers/ui";

import { isReloadPending } from "@app/store/accessChange";
import { RootState } from "@app/store/rootReducer";
import reloadPage from "@app/util/reloadPage";

const messages = defineMessages({
  reload: {
    id: "layout.accessChangeBar.reload",
    defaultMessage: "Reload page",
    description: "Access change banner: button that reloads the page",
  },
  reloadPending: {
    id: "layout.accessChangeBar.reloadPending",
    defaultMessage:
      "<b>This page is out of date.</b> Your access changed, and some actions may not work. Copy anything you need, then reload. Opening another page from the main menu reloads the page too.",
    description:
      "Banner shown after an admin changed the user's access while the page still shows the old access",
  },
});

const boldText = { b: (chunks: ReactNode[]) => <b>{chunks}</b> };

const AccessChangeBar = ({ reloadPending }: ReturnType<typeof mapStateToProps>) => {
  const intl = useIntl();

  if (!reloadPending) {
    return null;
  }

  return (
    <Alert
      action={
        <Button onClick={reloadPage} size="small" type="primary">
          {intl.formatMessage(messages.reload)}
        </Button>
      }
      banner
      message={intl.formatMessage(messages.reloadPending, boldText)}
      type="warning"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  reloadPending: isReloadPending(state),
});

export default connect(mapStateToProps)(AccessChangeBar);
